import { useRef, useState, useCallback } from "react";

export const BeforeAfter = ({ before, after, testid = "before-after-slider" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = useCallback((clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setPos(Math.min(96, Math.max(4, ((clientX - rect.left) / rect.width) * 100)));
  }, []);

  const onPointer = (e) => {
    if (e.buttons === 1 || e.type === "pointerdown") update(e.clientX);
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="relative aspect-[4/3] w-full cursor-ew-resize select-none overflow-hidden border border-seam"
      onPointerDown={onPointer}
      onPointerMove={onPointer}
    >
      <img src={after} alt="After reconditioning" className="absolute inset-0 h-full w-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="Worn component" className="absolute inset-0 h-full w-full max-w-none object-cover" style={{ width: ref.current?.offsetWidth || "100%" }} draggable={false} />
      </div>
      <div className="absolute inset-y-0 w-0.5 bg-spark" style={{ left: `${pos}%` }}>
        <span className="absolute left-1/2 top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-spark bg-obsidian font-mono text-[10px] text-spark">
          ⇔
        </span>
      </div>
      <span className="absolute left-3 top-3 bg-obsidian/80 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-cadmium">Before · Worn</span>
      <span className="absolute right-3 top-3 bg-spark px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-white">After · SABAKT</span>
    </div>
  );
};
